import axios from 'axios'

const state = {
  roles: [],
  rolesSingle: null,
}

const getters = {
  getRoles (state) {
    return state.roles
  },
  getRolesSingle (state) {
    return state.rolesSingle
  },
}

const mutations = {
  setRoles (state, payload) {
    state.roles = payload
  },
  setRolesSingle (state, payload) {
    state.rolesSingle = payload
  },
  clearRoleSingle (state) {
    state.rolesSingle = null
  },
}

const actions = {
  fetchRoles ({ commit, rootGetters }, meta) {
    meta = meta || {
      limit: 1000,
      offset: 0,
      page: 0,
    }
    return axios
      .get(
        `${rootGetters['api/rolesList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setRoles', res.data.items)

        return res
      })
      .catch((err) => err)
  },
  fetchAvailableRoleList ({ rootGetters }) {
    return axios
      .get(rootGetters['api/availableRoleList'])
      .then((res) => {
        return res.data.items
      })
      .catch((err) => err)
  },
  fetchViewableRoleList ({ rootGetters }) {
    return axios
      .get(rootGetters['api/viewableRoleList'])
      .then((res) => res.data.items)
  },
  fetchSingleRole ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/rolesSingle'](id))
      .then((res) => {
        commit('setRolesSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createRole ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/rolesCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  editRole ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/rolesEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteRole ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/rolesDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getRoles.filter((val) => val.id !== id)
          commit('setRoles', items)
        }

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
